<article class="fp-card" (click)="open()" [class.fp-card--pinned]="post.pinned">
  <!-- Coluna de voto -->
  <div class="fp-vote" (click)="$event.stopPropagation()">
    <button
      class="fp-vote__btn"
      [class.fp-vote__btn--up]="post.myVote === 1"
      (click)="vote(1, $event)"
      aria-label="Votar a favor"
    >
      <i class="pi pi-chevron-up"></i>
    </button>
    <span class="fp-vote__score" [class.fp-vote__score--up]="post.myVote === 1" [class.fp-vote__score--down]="post.myVote === -1">
      {{ short(post.score) }}
    </span>
    <button
      class="fp-vote__btn"
      [class.fp-vote__btn--down]="post.myVote === -1"
      (click)="vote(-1, $event)"
      aria-label="Votar contra"
    >
      <i class="pi pi-chevron-down"></i>
    </button>
  </div>

  <!-- Conteúdo -->
  <div class="fp-body">
    <!-- Meta -->
    <div class="fp-meta">
      <button
        *ngIf="!hideCommunity && community"
        class="fp-community"
        (click)="openCommunity($event)"
      >
        <span class="fp-community__icon" [style.background]="community.color">
          <i [class]="community.icon"></i>
        </span>
        <span class="fp-community__name">{{ community.name }}</span>
      </button>
      <span class="fp-meta__sep" *ngIf="!hideCommunity">·</span>
      <span class="fp-meta__author">
        {{ post.author.name }}
        <i class="pi pi-verified fp-meta__verified" *ngIf="post.author.isTunner" title="Verificado"></i>
      </span>
      <span class="fp-meta__sep">·</span>
      <span class="fp-meta__time">{{ post.createdAt }}</span>
      <span class="fp-pin" *ngIf="post.pinned"><i class="pi pi-bookmark-fill"></i> Fixado</span>
    </div>

    <!-- Título -->
    <h3 class="fp-title">
      <span class="fp-tag" *ngIf="post.tag" [style.background]="post.tagColor + '22'" [style.color]="post.tagColor">{{ post.tag }}</span>
      {{ post.title }}
    </h3>

    <!-- Trecho do corpo -->
    <p class="fp-excerpt">{{ post.body }}</p>

    <!-- Mídia placeholder -->
    <div class="fp-media" *ngIf="post.image">
      <div class="fp-media__ph" [attr.data-kind]="post.image">
        <i class="pi pi-image"></i>
        <span>{{ post.image === 'civic' ? 'Foto do projeto' : 'Print do datalogger' }}</span>
      </div>
    </div>

    <!-- Ações -->
    <div class="fp-actions">
      <span class="fp-action">
        <i class="pi pi-comment"></i>
        {{ post.commentsCount }} comentários
      </span>
      <button class="fp-action fp-action--btn" [class.fp-action--saved]="post.saved" (click)="toggleSave($event)">
        <i class="pi" [ngClass]="post.saved ? 'pi-bookmark-fill' : 'pi-bookmark'"></i>
        {{ post.saved ? 'Salvo' : 'Salvar' }}
      </button>
      <button class="fp-action fp-action--btn" (click)="$event.stopPropagation()">
        <i class="pi pi-share-alt"></i>
        Compartilhar
      </button>
    </div>
  </div>
</article>
